import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Split } from '../split';
/**
 * Class to track interesting properties (see https://15721.courses.cs.cmu.edu/spring2016/papers/graefe-ieee1995.pdf)
 * about how fields have been parsed or whether they have been derived in a transform. We use this to not parse the
 * same field again (or differently).
 */

export var AncestorParse =
/*#__PURE__*/
function (_Split) {
  _inherits(AncestorParse, _Split);

  function AncestorParse() {
    var _this;

    var explicit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var implicit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parseNothing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, AncestorParse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AncestorParse).call(this, explicit, implicit));
    _this.explicit = explicit;
    _this.implicit = implicit;
    _this.parseNothing = parseNothing;
    return _this;
  }

  _createClass(AncestorParse, [{
    key: "clone",
    value: function clone() {
      var clone = _get(_getPrototypeOf(AncestorParse.prototype), "clone", this).call(this);

      clone.parseNothing = this.parseNothing;
      return clone;
    }
  }]);

  return AncestorParse;
}(Split);